function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpoStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    viewBox: "0 0 295.239 295.239",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "transparent"
    },
    points: "19.048,292.858 19.048,235.715 47.619,197.62 76.19,178.572 104.762,192.858            133.333,226.191 161.905,226.191 190.476,164.287 219.048,130.953 247.619,97.62 276.19,73.81 276.19,292.858"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.19,26.191c-10.505,0-19.048,8.543-19.048,19.048c0,3.662,1.086,7.048,2.886,9.957         L152.124,181.082c-2.757-1.552-5.886-2.51-9.267-2.51c-5.29,0-10.076,2.176-13.533,5.667l-36.343-25.438         c1.395-2.648,2.257-5.61,2.257-8.8c0-10.505-8.543-19.048-19.048-19.048s-19.047,8.543-19.047,19.048         c0,3.524,1.024,6.781,2.7,9.614l-31.181,31.181c-2.833-1.676-6.09-2.7-9.614-2.7C8.543,188.096,0,196.639,0,207.144         s8.543,19.048,19.048,19.048s19.048-8.543,19.048-19.048c0-3.524-1.024-6.781-2.7-9.614l31.181-31.181         c2.833,1.676,6.09,2.7,9.614,2.7c3.833,0,7.386-1.157,10.376-3.114l38.014,26.61c-0.452,1.629-0.771,3.31-0.771,5.076         c0,10.505,8.543,19.048,19.048,19.048s19.048-8.543,19.048-19.048c0-3.662-1.086-7.048-2.886-9.957L266.924,61.777         c2.757,1.552,5.886,2.51,9.267,2.51c10.505,0,19.048-8.543,19.048-19.048S286.695,26.191,276.19,26.191z M19.048,216.668         c-5.252,0-9.524-4.271-9.524-9.524s4.271-9.524,9.524-9.524s9.524,4.271,9.524,9.524S24.3,216.668,19.048,216.668z M76.19,159.525         c-5.252,0-9.524-4.271-9.524-9.524c0-5.252,4.271-9.524,9.524-9.524s9.524,4.271,9.524,9.524         C85.714,155.253,81.443,159.525,76.19,159.525z M142.857,207.144c-5.252,0-9.524-4.271-9.524-9.524         c0-5.252,4.271-9.524,9.524-9.524c5.252,0,9.524,4.271,9.524,9.524C152.381,202.872,148.109,207.144,142.857,207.144z          M276.19,54.763c-5.252,0-9.524-4.271-9.524-9.524c0-5.253,4.271-9.524,9.524-9.524c5.252,0,9.524,4.271,9.524,9.524         C285.714,50.492,281.443,54.763,276.19,54.763z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.286,
    y: 235.715,
    width: 9.524,
    height: 57.143,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.857,
    y: 197.62,
    width: 9.524,
    height: 95.238,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.429,
    y: 178.572,
    width: 9.524,
    height: 114.286,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 192.858,
    width: 9.524,
    height: 100,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.571,
    y: 226.191,
    width: 9.524,
    height: 66.667,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.143,
    y: 226.191,
    width: 9.524,
    height: 66.667,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.714,
    y: 164.287,
    width: 9.524,
    height: 128.571,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.286,
    y: 130.953,
    width: 9.524,
    height: 161.905,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.857,
    y: 97.62,
    width: 9.524,
    height: 195.238,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.428,
    y: 73.81,
    width: 9.524,
    height: 219.048,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "61.905,78.572 47.619,78.572 47.619,11.906 61.905,11.906 61.905,2.382 23.81,2.382            23.81,11.906 38.095,11.906 38.095,78.572 23.81,78.572 23.81,88.096 61.905,88.096"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.714,50.001h19.048c13.129,0,23.81-10.681,23.81-23.81s-10.681-23.81-23.81-23.81H76.19v85.714         h9.524C85.714,88.095,85.714,50.001,85.714,50.001z M85.714,11.906h19.048c7.876,0,14.286,6.41,14.286,14.286         s-6.41,14.286-14.286,14.286H85.714V11.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M171.429,88.096c15.757,0,28.571-12.814,28.571-28.571V30.953         c0-15.757-12.814-28.571-28.571-28.571s-28.571,12.814-28.571,28.571v28.571C142.857,75.282,155.671,88.096,171.429,88.096z          M152.381,30.953c0-10.505,8.543-19.048,19.048-19.048s19.048,8.543,19.048,19.048v28.571c0,10.505-8.543,19.048-19.048,19.048         s-19.048-8.543-19.048-19.048V30.953z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpoStocks);
export default __webpack_public_path__ + "static/media/IpoStocks.587f5cae5368d9b2b9bdf3267c877d5c.svg";
export { ForwardRef as ReactComponent };